import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {ButtonMain, UploadSingle} from "components";
import {ImportedCSVTypesList} from "fragments";
import {Svg} from "assets";
import {fileDownload, fileUpload, FindError, FindLoad, FindSuccess, useModal} from "utils";
import {httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, legsActions} from "store";

const UPLOAD_CSV_ACTION_TYPE = 'LEG_CSV_IMPORT';

export const ImportCsv = () => {
    const [currentFile, setCurrentFile] = useState(null);
    const [backError, setBackError] = useState(false);
    const [isImported, setIsImported] = useState(false);
    const {importedLegs} = useSelector((state) => ({
        importedLegs: state.legs?.importedLegs,
    }));
    const dispatch = useDispatch();
    const {control, handleSubmit} = useForm();
    const {close} = useModal();
    const loadingSendCsv = FindLoad(UPLOAD_CSV_ACTION_TYPE);
    const successSendCsv = FindSuccess(UPLOAD_CSV_ACTION_TYPE);
    const beckErrorSendCsv = FindError(UPLOAD_CSV_ACTION_TYPE);


    useEffect(() => {
        if (beckErrorSendCsv?.error) {
            dispatch(httpRequestsOnErrorsActions.removeError(UPLOAD_CSV_ACTION_TYPE))
            toast.error('File upload failed. Please try again.')
        }

    }, [beckErrorSendCsv]);


    useEffect(() => {
        if (successSendCsv?.type && importedLegs) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(UPLOAD_CSV_ACTION_TYPE));

            if (importedLegs?.failed || importedLegs?.succeeded) {
                setIsImported(true);
            }

            if (importedLegs?.failedCSV?.url) {
                window.open(importedLegs?.failedCSV?.url, '_self');
            }
        }

    }, [successSendCsv, importedLegs])


    const uploadCSV = () => {
        if (!currentFile) {
            setBackError(true);
        } else {
            const formData = fileUpload(currentFile?.file);
            // dispatch(legsActions.uploadLegCsv(formData, data?.type))
            dispatch(legsActions.uploadLegCsv(formData))
        }
    };


    return (
        <div className='export-csv-wrapper'>
            <div className="modal-header-main">
                <h2 className="modal-header-title">Import CSV</h2>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={close}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>
            {!isImported ?
                <form onSubmit={handleSubmit(uploadCSV)}>
                    <div className="modal-body-main">
                        <UploadSingle
                            currentFile={currentFile}
                            setCurrentFile={setCurrentFile}
                            backError={backError}
                            setBackError={setBackError}
                            supportedFormats={["CSV"]}
                            // selectOptions={{
                            //     control,
                            //     name: 'type',
                            //     list: ImportedCSVTypesList,
                            //     rules: {
                            //         required: "This field is required",
                            //     }
                            // }}
                        />
                    </div>

                    <div className="modal-footer-main">
                        <ButtonMain
                            text="Cancel"
                            cancel
                            onClick={close}
                        />
                        <ButtonMain
                            text={'Import'}
                            load={!!loadingSendCsv?.length}
                            type="submit"
                        />
                    </div>
                </form>
                :
                <div className='imported-legs-info-wrapper'>
                    <div className='modal-body-main'>
                        <div className='imported-legs-info-block'>
                            {!!importedLegs?.succeeded &&
                                <div
                                    className='imported-legs-info-item'
                                    style={{
                                        background: 'rgba(23, 185, 134, 0.15)'
                                    }}
                                >
                                    <Svg.SuccessSvg/>

                                    <p className='imported-legs-info-item-text'>
                                        Success: {importedLegs?.succeeded} rows were successfully imported.
                                    </p>
                                </div>
                            }

                            {!!importedLegs?.failed &&
                                <div
                                    className='imported-legs-info-item'
                                    style={{
                                        background: 'rgba(230, 57, 70, 0.15)'
                                    }}
                                >
                                    <Svg.ErrorSvg/>

                                    <p className='imported-legs-info-item-text'>
                                        Error: {importedLegs?.failed} rows failed to import.
                                    </p>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="modal-footer-main">
                        <ButtonMain
                            text={'Done'}
                            load={!!loadingSendCsv?.length}
                            type="button"
                            onClick={close}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

